import axios from './index'
import store from '@/store'
import { cleanParams } from '@/filters'
// 获取itemKey
export const getAttrCategory = () => {
  const currentRole = store.state.currentRole
  const { companyId, teamId } = currentRole
  return axios.get('/welldbCombine/itemKey', {
    params: cleanParams({
      pageNum: 1,
      pageSize: 10000,
      companyId,
      teamId
    })
  })
}
// 获取所有属性
export const getAllAttrCategory = () => {
  const currentRole = store.state.currentRole
  const { companyId, teamId } = currentRole
  return axios.get('/welldbCombine/itemKey/allCategory', {
    params: cleanParams({
      companyId,
      teamId
    })
  })
}
// 新增itemKey
export const addAttrCategory = (params) => {
  const user = store.state.userInfo
  const currentRole = store.state.currentRole
  const { companyId, teamId } = currentRole
  return axios.post('/welldbCombine/itemKey', {
    params: cleanParams({ ...params, companyId, teamId, createUserId: user.userId }),
    moveToQuery: true
  })
}
// 更新itemKey
export const updateAttrCategory = (params) => {
  return axios.put('/welldbCombine/itemKey', {
    params: params,
    moveToQuery: true
  })
}
// 删除itemKey
export const deleteAttrCategory = (id) => {
  return axios.delete('/welldbCombine/itemKey', {
    params: {
      id
    }
  })
}
// 获取itemKey下的itemValue
export const getAttrValue = (id) => {
  return axios.get('/welldbCombine/itemValue', {
    params: cleanParams({
      pageNum: 1,
      pageSize: 1000,
      itemKeyId: id
    })
  })
}
// 获取itemValue的子itemValue
export const getAttrSubValue = (id) => {
  return axios.get('/welldbCombine/itemValue', {
    params: cleanParams({
      pageNum: 1,
      pageSize: 1000,
      parentId: id
    })
  })
}
// 按id获取一个itemValue信息
export const getItemValueById = (id) => {
  return axios.get('/welldbCombine/itemValue', {
    params: { id }
  })
}
export const getItemValueParent = itemValue => {
  let type = ''
  let id = ''
  if (itemValue.parentId) {
    type = 'itemValue'
    id = itemValue.parentId
  } else if (itemValue.itemKeyId) {
    type = 'itemKey'
    id = itemValue.itemKeyId
  }
  if (!type || !id) {
    return Promise.reject(new Error('没有父级信息'))
  }
  return axios.get(`/welldbCombine/${type}`, {
    params: { id }
  })
}

// 新增itemValue
export const addAttrValue = (params) => {
  return axios.post('/welldbCombine/itemValue', {
    params: params,
    moveToQuery: true
  })
}
// 更新itemValue
export const updateAttrValue = (params) => {
  return axios.put('/welldbCombine/itemValue', {
    params: params,
    moveToQuery: true
  })
}
// 删除itemValue
export const deleteAttrValue = (id) => {
  return axios.delete('/welldbCombine/itemValue', {
    params: {
      id
    }
  })
}
// 获取一个item的itemValue
export const getAttrOfItem = (id) => {
  return axios.get('/welldbCombine/itemAndItemValue', {
    params: {
      itemId: id,
      pageNum: 1,
      pageSize: 10000
    }
  })
}
// 绑定itemValue到item
export const addAttrToItem = (params) => {
  return axios.post('/welldbCombine/itemAndItemValue', {
    moveToQuery: true,
    params
  })
}
// 删除一个item上的itemValue绑定
export const deleteAttrFromItem = (id) => {
  return axios.delete('/welldbCombine/itemAndItemValue', {
    params: {
      id
    }
  })
}
